import {
  LIST_EXPORT_BILLING_REQUEST,
  LIST_EXPORT_BILLING_SUCCESS,
  LIST_EXPORT_BILLING_FAIL,
  DOWNLOAD_EXPORT_BILLING_REQUEST,
  DOWNLOAD_EXPORT_BILLING_SUCCESS,
  DOWNLOAD_EXPORT_BILLING_FAIL,
  EXPORT_EXPORT_BILLING_REQUEST,
  EXPORT_EXPORT_BILLING_SUCCESS,
  EXPORT_EXPORT_BILLING_FAIL
} from '../../../constants/exports/export-billing'

const initialState = {
  loading: false,
  loadingExportBillingDownload: false,
  loadingExportBillingExport: false,
  exportBilling: [],
  exportBillingDetail: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listExportBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXPORT_BILLING_REQUEST:
      return { ...state, loading: true }
    case LIST_EXPORT_BILLING_SUCCESS:
      return {
        ...state,
        loading: false,
        exportBilling: action.payload,
        pageable: action.pageable
      }
    case LIST_EXPORT_BILLING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        exportBilling: action?.dummy
      }
    case DOWNLOAD_EXPORT_BILLING_REQUEST:
      return { ...state, loadingExportBillingDownload: true }
    case DOWNLOAD_EXPORT_BILLING_SUCCESS:
      return {
        ...state,
        loadingExportBillingDownload: false,
        exportBillingDetail: action.payload,
        pageable: state.pageable
      }
    case DOWNLOAD_EXPORT_BILLING_FAIL:
      return {
        ...state,
        loadingExportBillingDownload: false,
        error: action.payload
      }
    case EXPORT_EXPORT_BILLING_REQUEST:
      return { ...state, loadingExportBillingExport: true, error: null }
    case EXPORT_EXPORT_BILLING_SUCCESS:
      return {
        ...state,
        loadingExportBillingExport: false,
        error: null
      }
    case EXPORT_EXPORT_BILLING_FAIL:
      return {
        ...state,
        loadingExportBillingExport: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default listExportBillingReducer
